import { render, staticRenderFns } from "./EditorFooter.vue?vue&type=template&id=accdf1de&scoped=true&"
import script from "./EditorFooter.vue?vue&type=script&lang=js&"
export * from "./EditorFooter.vue?vue&type=script&lang=js&"
import style0 from "./EditorFooter.vue?vue&type=style&index=0&id=accdf1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accdf1de",
  null
  
)

export default component.exports